import React, { FunctionComponent, useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import i18next from 'i18next';
import { ViewContainer, ViewContent, Title } from 'styles/view';
import TriStateSwitch from 'components/commons/TriStateSwitch';
import { ISystemStatus, IUpdateSystemStatusPayload } from 'types/systemStatus.types';
import { StatusDescriptionBox } from './styles';
import './i18n';

interface Props {
  status: ISystemStatus | null;
  onSave: (values: IUpdateSystemStatusPayload) => void;
}

type SystemMode = 'MAINTENANCE' | 'LANDING';

const SystemStatusView: FunctionComponent<Props> = ({ status, onSave }) => {
  const getSwitchValue = (): SystemMode => {
    if (!status) return 'LANDING';

    const isMaintenance = status.maintenanceMode;
    const isLanding = status.showLandingPage;

    if (isMaintenance) return 'MAINTENANCE';
    if (isLanding) return 'LANDING';

    return 'LANDING';
  };

  const [localVal, setLocalVal] = useState<SystemMode>(getSwitchValue());

  useEffect(() => {
    const remoteValue = getSwitchValue();
    setLocalVal(remoteValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const handleSwitchChange = (val: SystemMode) => {
    setLocalVal(val); // Cambio visual inmediato

    const payload: IUpdateSystemStatusPayload = {
      maintenanceMode: val === 'MAINTENANCE',
      showLandingPage: val === 'LANDING',
    };
    onSave(payload);
  };

  return (
    <ViewContainer auth>
      <Title>{i18next.t<string>('SYSTEM_STATUS:TITLE')}</Title>

      <ViewContent auth>
        <Typography variant="subtitle1" gutterBottom>
          {i18next.t<string>('SYSTEM_STATUS:CONFIG_DESCRIPTION')}
        </Typography>

        <TriStateSwitch value={localVal} onChange={handleSwitchChange} />

        <StatusDescriptionBox>
          <Typography variant="body2" color="textSecondary">
            {localVal === 'MAINTENANCE' &&
              i18next.t<string>('SYSTEM_STATUS:DESCRIPTION_MAINTENANCE')}
            {localVal === 'LANDING' && i18next.t<string>('SYSTEM_STATUS:DESCRIPTION_LANDING')}
          </Typography>
        </StatusDescriptionBox>
      </ViewContent>
    </ViewContainer>
  );
};

export default SystemStatusView;
